import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useResponsive } from '../hooks/useResponsive';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import fondpropos1 from '../fondpropos1.png';
import comment1 from '../comment1.png';
import coeurs from '../coeurs.png';
import {
    FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash,
    FaShieldAlt, FaUsers, FaArrowRight
} from 'react-icons/fa';
import { GoShieldCheck } from 'react-icons/go';
import { AiOutlineHeart } from 'react-icons/ai';
import { MdOutlineLock, MdOutlinePeople } from 'react-icons/md';

const Login = () => {
    // "Se souvenir de moi" (comportement A) : on mémorise l'adresse email
    // pour la pré-remplir au prochain login. On lit la valeur mémorisée au
    // premier rendu, pour initialiser le champ et cocher la case.
    const rememberedEmail = localStorage.getItem('rememberedEmail') || '';

    const [email, setEmail] = useState(rememberedEmail);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPwd, setShowPwd] = useState(false);
    const [remember, setRemember] = useState(!!rememberedEmail);
    const { login } = useAuth();
    const navigate = useNavigate();

    const { isMobile, isTablet, isSmall } = useResponsive();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            // "Se souvenir de moi" (A) : on mémorise ou on efface l'email saisi,
            // pour le pré-remplir (ou non) au prochain passage sur cette page.
            if (remember) {
                localStorage.setItem('rememberedEmail', email);
            } else {
                localStorage.removeItem('rememberedEmail');
            }

            const user = await login(email, password);
            if (user.role === 'admin' || user.role === 'moderateur') navigate('/admin');
            else navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.message || 'Erreur de connexion');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', overflowX: 'hidden', backgroundColor: '#fff' }}>

            {/* Navbar */}
            <Navbar />

            {/* ═══════════ HERO ═══════════ */}
            <section style={{
                position: 'relative',
                backgroundColor: '#fdf2f8',
                overflow: 'hidden',
                minHeight: isMobile ? 'auto' : '640px',
            }}>
                {!isMobile && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: isTablet ? '50%' : '52%',
                        height: isTablet ? '48%' : '52%',
                        backgroundImage: `url(${comment1})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        zIndex: 1,
                        WebkitMaskImage: 'linear-gradient(to bottom, black 65%, transparent 100%), linear-gradient(to left, black 70%, transparent 100%)',
                        WebkitMaskComposite: 'source-in',
                        maskImage: 'linear-gradient(to bottom, black 65%, transparent 100%), linear-gradient(to left, black 70%, transparent 100%)',
                        maskComposite: 'intersect',
                    }} />
                )}

                <div style={{
                    position: 'relative', zIndex: 2,
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    maxWidth: '1200px', margin: '0 auto',
                }}>
                    {/* ── Colonne gauche ── */}
                    <div style={{
                        flex: isMobile ? 'none' : '0 0 40%',
                        padding: isSmall ? '24px 16px' : isMobile ? '32px 20px' : isTablet ? '40px 32px' : '48px 48px',
                        display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    }}>
                        <div style={{ maxWidth: '440px', width: '100%', margin: '0 auto' }}>

                            <p style={{ color: '#c0306a', fontSize: '11px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '8px', marginTop: 0 }}>SE CONNECTER</p>
                            <h1 style={{
                                color: '#1a0010', fontWeight: '700',
                                fontSize: isSmall ? '28px' : isMobile ? '32px' : '40px',
                                lineHeight: '1.2', marginBottom: '12px', marginTop: 0,
                                fontFamily: 'Cormorant Garamond, serif',
                            }}>
                                Ravi de vous<br />
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <span style={{ color: '#c0306a' }}>retrouver</span>
                                    <img src={coeurs} alt="" style={{ height: isMobile ? '40px' : '50px', marginLeft: '-6px', marginTop: '6px' }} />
                                </span>
                            </h1>
                            <p style={{ color: '#666', fontSize: '13px', lineHeight: '1.7', marginBottom: '24px', marginTop: 0 }}>
                                Connectez-vous pour accéder à votre compte et continuer votre recherche en toute sérénité.
                            </p>

                            {/* Carte formulaire */}
                            <div style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '20px',
                                boxShadow: '0 8px 40px rgba(120,24,64,0.10)',
                                padding: isSmall ? '24px 20px' : isMobile ? '28px 24px' : '32px 32px',
                            }}>
                                {error && (
                                    <div style={{ backgroundColor: '#ffe0e0', color: '#c00', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '13px' }}>
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    {/* Email */}
                                    <div style={{ marginBottom: '16px' }}>
                                        <label style={{ display: 'block', color: '#1a0010', fontSize: '13px', fontWeight: '600', marginBottom: '7px' }}>Adresse email</label>
                                        <div style={{ position: 'relative' }}>
                                            <FaEnvelope style={{ position: 'absolute', left: '13px', top: '50%', transform: 'translateY(-50%)', color: '#c0306a' }} size={13} />
                                            <input
                                                type="email"
                                                value={email}
                                                onChange={e => setEmail(e.target.value)}
                                                placeholder="Entrez votre adresse e-mail"
                                                required
                                                style={{ width: '100%', padding: '11px 14px 11px 36px', border: '1.5px solid #eedde6', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', color: '#333', backgroundColor: '#fff' }}
                                            />
                                        </div>
                                    </div>

                                    {/* Mot de passe */}
                                    <div style={{ marginBottom: '12px' }}>
                                        <label style={{ display: 'block', color: '#1a0010', fontSize: '13px', fontWeight: '600', marginBottom: '7px' }}>Mot de passe</label>
                                        <div style={{ position: 'relative' }}>
                                            <FaLock style={{ position: 'absolute', left: '13px', top: '50%', transform: 'translateY(-50%)', color: '#c0306a' }} size={13} />
                                            <input
                                                type={showPwd ? 'text' : 'password'}
                                                value={password}
                                                onChange={e => setPassword(e.target.value)}
                                                placeholder="Entrez votre mot de passe"
                                                required
                                                style={{ width: '100%', padding: '11px 38px 11px 36px', border: '1.5px solid #eedde6', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', color: '#333', backgroundColor: '#fff' }}
                                            />
                                            <button type="button" onClick={() => setShowPwd(!showPwd)} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', padding: 0 }}>
                                                {showPwd ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Se souvenir + mot de passe oublié */}
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', flexWrap: 'wrap', gap: '8px' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#555' }}>
                                            <input type="checkbox" checked={remember} onChange={e => setRemember(e.target.checked)} style={{ accentColor: '#c0306a', width: '15px', height: '15px' }} />
                                            Se souvenir de moi
                                        </label>
                                        <Link to="/mot-de-passe-oublie" style={{ color: '#c0306a', fontSize: '13px', textDecoration: 'none', fontWeight: '500' }}>Mot de passe oublié ?</Link>
                                    </div>

                                    {/* Bouton connexion */}
                                    <button type="submit" disabled={loading} style={{ width: '100%', padding: '13px', background: 'linear-gradient(135deg, #3d0820, #781840)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', cursor: 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '20px', boxShadow: '0 4px 16px rgba(120,24,64,0.3)', fontFamily: 'Arial, sans-serif' }}>
                                        <FaArrowRight size={14} /> {loading ? 'Connexion...' : 'Se connecter'}
                                    </button>

                                    <p style={{ textAlign: 'center', color: '#666', fontSize: '13px', margin: 0 }}>
                                        Vous n'avez pas encore de compte ?{' '}
                                        <Link to="/register" style={{ color: '#c0306a', fontWeight: '600', textDecoration: 'none' }}>Créer un compte →</Link>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* ── Colonne droite : card avantages ── */}
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        padding: isMobile ? '8px 20px 32px' : isTablet ? '40px 24px 48px' : '48px 48px 56px',
                        margin: isMobile ? '40px 16px 20px' : '48px 48px 0px',
                    }}>
                        <div style={{
                            width: '100%', maxWidth: '380px',
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            padding: isTablet ? '20px' : '34px',
                            boxShadow: '0 8px 32px rgba(192,48,106,0.12)',
                        }}>
                            <h2 style={{
                                color: '#1a0010',
                                fontSize: isTablet ? '18px' : '22px',
                                fontWeight: '700', lineHeight: '1.4',
                                marginBottom: '20px', marginTop: 0,
                                fontFamily: 'Cormorant Garamond, serif',
                                textAlign: 'left', paddingLeft: '45px',
                            }}>
                                Une connexion sécurisée <br />pour une expérience sereine
                            </h2>
                            {[
                                { icon: <GoShieldCheck size={18} color="#781840" />, title: 'Sécurité & confidentialité', text: 'Vos données sont protégées et ne sont jamais partagées.' },
                                { icon: <AiOutlineHeart size={18} color="#781840" />, title: 'Espace personnalisé', text: 'Accédez à vos discussions, favoris et recherches enregistrées.' },
                                { icon: <MdOutlineLock size={18} color="#781840" />, title: 'Plateforme éthique', text: 'Un environnement respectueux, conforme aux valeurs islamiques.' },
                                { icon: <MdOutlinePeople size={18} color="#781840" />, title: 'Accompagnement bienveillant', text: 'Des outils et conseils pour vous guider vers une union bénie.' },
                            ].map((item, i) => (
                                <div key={i} style={{
                                    display: 'flex', gap: '12px',
                                    marginBottom: i < 3 ? '16px' : '0',
                                    alignItems: 'flex-start',
                                }}>
                                    <div style={{
                                        flexShrink: 0, width: '36px', height: '36px',
                                        borderRadius: '18px',
                                        backgroundColor: 'rgba(192,48,106,0.08)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        {item.icon}
                                    </div>
                                    <div>
                                        <p style={{ color: '#1a0010', fontSize: isTablet ? '12px' : '13px', fontWeight: '700', margin: '0 0 2px 0' }}>{item.title}</p>
                                        <p style={{ color: '#666', fontSize: '12px', lineHeight: '1.5', margin: 0 }}>{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </section>

            {/* ═══════════ 4 BADGES ═══════════ */}
            <section style={{ backgroundColor: '#fdf2f8', padding: isMobile ? '32px 16px' : '48px 24px' }}>
                <div style={{
                    maxWidth: '1080px', margin: '0 auto',
                    backgroundColor: 'white',
                    borderRadius: '20px',
                    boxShadow: '0 1px 6px gray',
                    padding: isMobile ? '24px 16px' : '36px 32px',
                    display: 'grid',
                    gridTemplateColumns: isSmall ? '1fr 1fr' : isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                    gap: isSmall ? '20px' : '0px',
                }}>
                    {[
                        { icon: <GoShieldCheck size={24} color="#781840" />, title: '100% Sécurisé', text: 'Vos informations sont protégées et cryptées.' },
                        { icon: <FaUsers size={24} color="#781840" />, title: 'Profils vérifiés', text: 'Des profils authentiques pour des rencontres sérieuses.' },
                        { icon: <AiOutlineHeart size={24} color="#781840" />, title: 'Respect & Bienveillance', text: 'Une communauté basée sur le respect et les valeurs islamiques.' },
                        { icon: <FaShieldAlt size={24} color="#781840" />, title: "Conforme à l'éthique islamique", text: "Nos pratiques sont conformes aux enseignements de l'Islam." },
                    ].map((b, i) => (
                        <div key={i} style={{
                            textAlign: 'center',
                            padding: isSmall ? '8px' : '8px 20px',
                            borderRight: (!isMobile && i < 3) ? '1px solid rgba(192,48,106,0.15)' : 'none',
                        }}>
                            <div style={{
                                width: isSmall ? '52px' : '60px',
                                height: isSmall ? '52px' : '60px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(192,48,106,0.08)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                margin: '0 auto 14px',
                                boxShadow: '0 2px 12px rgba(192,48,106,0.10)',
                            }}>
                                {b.icon}
                            </div>
                            <h4 style={{ color: '#1a0010', fontSize: isSmall ? '13px' : '14px', fontWeight: '700', marginBottom: '8px', marginTop: 0 }}>{b.title}</h4>
                            <p style={{ color: '#999', fontSize: isSmall ? '11px' : '12px', lineHeight: '1.6', margin: 0 }}>{b.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ═══════════ CTA BAS ═══════════ */}
            <section style={{ backgroundColor: '#fdf2f8', padding: isMobile ? '32px 16px' : '48px 24px' }}>
                <div style={{
                    position: 'relative',
                    maxWidth: '1150px', margin: '0 auto',
                    borderRadius: '20px',
                    boxShadow: '0 1px 6px gray',
                    backgroundImage: `url(${fondpropos1})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}>
                    <div style={{ position: 'absolute', inset: 0 }} />
                    <div style={{
                        position: 'relative', zIndex: 2,
                        display: 'flex', flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'center', justifyContent: 'space-between',
                        padding: isMobile ? '24px 16px' : '36px 32px',
                        gap: '24px',
                    }}>
                        <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
                            <h2 style={{ color: '#1a0010', fontSize: isSmall ? '20px' : isMobile ? '22px' : '26px', fontWeight: '700', marginBottom: '10px', marginTop: 0, fontFamily: 'Cormorant Garamond, serif' }}>
                                Pas encore inscrit(e) ?
                            </h2>
                            <p style={{ color: '#5a4450', fontSize: '13px', lineHeight: '1.7', margin: '0 0 6px 0' }}>
                                Rejoignez une communauté sérieuse et éthique.<br />Faites le premier pas pour une union bénie.
                            </p>
                            <p style={{ color: '#9b8590', fontSize: '12px', margin: 0 }}>C'est rapide, simple et gratuit.</p>
                        </div>
                        <button onClick={() => navigate('/register')} style={{ flexShrink: 0, padding: isSmall ? '12px 20px' : '13px 28px', backgroundColor: '#4a0028', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap', boxShadow: '0 4px 16px rgba(192,48,106,0.4)', fontFamily: 'Arial, sans-serif' }}>
                            <FaUser size={13} /> Créer un compte gratuitement
                        </button>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <Footer />

        </div>
    );
};

export default Login;